import { render, staticRenderFns } from "./FiltroRelatoriosTurma.vue?vue&type=template&id=498579d7&"
import script from "./FiltroRelatoriosTurma.vue?vue&type=script&lang=js&"
export * from "./FiltroRelatoriosTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports